import { WebStorageStateStore } from "oidc-client-ts";
import type { User } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";
import type { SiteOidc } from "../types/oidc";

const host: string = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ""
}`;

const onSigninCallback = (_user: User | void): void => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const oidcConfig = (
  siteOidc: SiteOidc,
  userType: string = "full",
  schoolCode?: string | null,
): AuthProviderProps => {
  const studentUser = userType === "student";
  let scope = siteOidc.scope;
  let loginOptions = "v1_signup";
  if (studentUser && siteOidc.allowStudentScope) {
    scope += " student";
    loginOptions = schoolCode
      ? `v1_signup,school_code=${schoolCode}`
      : "v1_signup";
  }

  // Skip callback processing for Google Auth routes (OIDC client checks for code/state
  // params regardless of path, so we need to explicitly skip)
  const isGoogleOAuthCallback =
    window.location.pathname === "/auth/google/callback";

  return {
    client_id: siteOidc.client_id,
    redirect_uri: `${host}/auth/callback`,
    post_logout_redirect_uri: host,
    response_type: "code",
    scope,
    authority: process.env.REACT_APP_AUTHENTICATION_URL,
    silent_redirect_uri: `${host}/auth/silent_renew`,
    automaticSilentRenew: true,
    onSigninCallback,
    skipSigninCallback: isGoogleOAuthCallback,
    filterProtocolClaims: false,
    loadUserInfo: false,
    monitorSession: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    extraQueryParams: {
      brand: siteOidc.brand,
      login_options: loginOptions,
    },
  };
};

export const getOidcAuthKey = (clientId: string): string => {
  return `oidc.user:${process.env.REACT_APP_AUTHENTICATION_URL}:${clientId}`;
};
